import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PageResolverComponent } from './page-resolver.component';
import { ReviewPageRendererResolverComponent } from './review-page-renderer-resolver.component';

const components = [PageResolverComponent, ReviewPageRendererResolverComponent];

// tslint:disable-next-line: completed-docs
@NgModule({
  declarations: [...components],
  exports: [...components],
  imports: [CommonModule]
})
export class PageResolverModule {}
